import React, { useState, useEffect } from "react";
import Form, {
  Item,
  Label,
  ButtonItem,
  ButtonOptions,
  GroupItem,
} from "devextreme-react/form";
import Popup from "devextreme-react/popup";
import LoadIndicator from "devextreme-react/load-indicator";
import FileUploader from "devextreme-react/file-uploader";
import { useAuth } from "../../contexts/auth";
import axios from "axios";
import { backendlink } from "../../config";
import { Toast } from "devextreme-react/toast";
import GroupCaption from "../../pages/group-caption/GroupCaption";
import PartnerEcgDeviceSearchCustomerForm from "../partner-ecg-device-search-customer-form/PartnerEcgDeviceSearchCustomerForm";

export default function PartnerCustomerAssignEcgDeviceForm({ fetchTrigger }) {
  const { user } = useAuth();

  const [loadingSearchButton, setLoadingSearchButton] = useState(false);

  const [searchOrganizationPopupVisible, setSearchOrganizationPopupVisible] =
    useState(false);

  const [formData, setFormData] = useState({
    serialNos: "",
    organizationName: "",
    organizationToken: "",
  });

  const openSearchOrganizationPopup = () =>
    setSearchOrganizationPopupVisible(true);

  const closeSearchOrganizationPopup = () =>
    setSearchOrganizationPopupVisible(false);

  const onFileChanged = (e) => {
    const files = e.value;
    if (files.length === 0) return;

    const file = files[0];
    const reader = new FileReader();

    reader.onload = (evt) => {
      const text = evt.target.result;
      const lines = text.split(/\r\n|\n/);
      const ids = lines
        .map((line) => line.split(",")[0].trim())
        .filter((id) => id);

      setFormData((prev) => ({
        ...prev,
        serialNos: ids.join(", "),
      }));
    };

    reader.readAsText(file);
  };

  const onSelectOrganization = (data) => {
    if (data) {
      setFormData((prev) => ({
        ...prev,
        organizationName: data[0].organizationName,
        organizationToken: data[0].organizationToken,
      }));
    }

    setSearchOrganizationPopupVisible(false);
  };

  const [toastConfig, setToastConfig] = useState({
    isVisible: false,
    type: "success",
    message: "",
  });

  const groupCaptionNamedRender = (iconName) => {
    const groupCaptionRender = (data) => (
      <GroupCaption iconName={iconName} {...data} />
    );
    return groupCaptionRender;
  };

  const assignToOrganization = async () => {
    if (!formData.organizationToken || !formData.serialNos) {
      setToastConfig({
        ...toastConfig,
        isVisible: true,
        type: "error",
        message: "Invalid input",
      });
    } else {
      try {
        const response = await axios
          .post(
            backendlink + "partner/updatecustecgdevices",
            {
              serialNos: formData.serialNos,
              distributorToken: user.userToken,
              organizationToken: formData.organizationToken,
              action: "assign-to-organization",
            },
            {
              headers: {
                token: user.token,
              },
            }
          )
          .then((res) => {
            setLoadingSearchButton(false);

            if (res.data.errorno === 0) {
              setToastConfig({
                ...toastConfig,
                isVisible: true,
                type: "success",
                message: res.data.errmessage,
              });

              setFormData({
                serialNos: "",
                organizationName: "",
                organizationToken: "",
              });
            } else {
              setToastConfig({
                ...toastConfig,
                isVisible: true,
                type: "error",
                message: res.data.errmessage,
              });
            }
          });
      } catch (error) {
        setLoadingSearchButton(false);
        alert(error);
      }
    }
  };

  useEffect(() => {}, [user, fetchTrigger]);

  function onClickExportCsvButton() {
    const csvData = `ABC12345
    CDE67890`;
    const blob = new Blob([csvData], { type: "text/csv;charset=utf-8;" });

    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "sample.csv");

    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }

  function onHiding() {
    setToastConfig({
      ...toastConfig,
      isVisible: false,
    });
  }

  return (
    <div>
      <form>
        <Form formData={formData} style={{ paddingTop: "20px" }}>
          <GroupItem
            iconName="user"
            captionRender={groupCaptionNamedRender("user")}
            caption="Assign Device"
            colCount={20}
          >
            <Item
              colSpan={15}
              dataField={"serialNos"}
              editorOptions={{ readOnly: true }}
            >
              <Label text="Device Id(s)" />
            </Item>
            
            <ButtonItem>
              <ButtonOptions
                icon="download"
                type={"default"}
                useSubmitBehavior={false}
                onClick={onClickExportCsvButton}
              />
            </ButtonItem>

            <Item colSpan={4}>
              <FileUploader
                selectButtonText="Select CSV file"
                accept=".csv"
                labelText=""
                uploadMode="useForm"
                onValueChanged={onFileChanged}
                multiple={false}
                style={{ marginTop: "15px" }}
              />
            </Item>

            <Item
              colSpan={19}
              dataField={"organizationName"}
              editorOptions={{ readOnly: true }}
            >
              <Label text="Organization Name" />
            </Item>
            <ButtonItem>
              <ButtonOptions
                icon="find"
                type={"default"}
                useSubmitBehavior={false}
                onClick={openSearchOrganizationPopup}
              />
            </ButtonItem>
          </GroupItem>

          <ButtonItem colSpan={2} cssClass="full-width-button">
            <ButtonOptions
              width={"100%"}
              type={"default"}
              useSubmitBehavior={false}
              onClick={assignToOrganization}
            >
              <span className="dx-button-text">
                {loadingSearchButton ? (
                  <LoadIndicator
                    width={"24px"}
                    height={"24px"}
                    visible={true}
                  />
                ) : (
                  "Assign"
                )}
              </span>
            </ButtonOptions>
          </ButtonItem>
        </Form>
      </form>

      <Toast
        visible={toastConfig.isVisible}
        message={toastConfig.message}
        type={toastConfig.type}
        onHiding={onHiding}
        displayTime={2000}
      />

      <Popup
        visible={searchOrganizationPopupVisible}
        showCloseButton={true}
        showTitle={false}
        onHiding={() => setSearchOrganizationPopupVisible(false)}
        hideOnOutsideClick
        dragEnabled={true}
        width={1000}
        height={800}
      >
        <PartnerEcgDeviceSearchCustomerForm
          onSelect={onSelectOrganization}
          onClose={closeSearchOrganizationPopup}
        />
      </Popup>
    </div>
  );
}